/** @returns Whether the given url is on the current domain */
export function isCurrentDomain(url: string) {
  try {
    const currentUrl = new URL(window.location.href)
    return currentUrl.hostname === new URL(url).hostname
  } catch (e) {
    return false
  }
}
